<template>
  <div class="test-page container">
    <h1 class="title">Test Page</h1>
    <div class="content">
      <div class="test-board blue merida">
        <div ref="board" class="cg-board-wrap"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chessground } from "chessground";

export default {
  name: "TestPage",

  components: {},

  data() {
    return {};
  },

  mounted() {
    this.ui = Chessground(this.$refs.board, {
      coordinates: true,
    });
  },
};
</script>

<style>
/* Using global styles to override Chessground's default styles */
.test-board .cg-board-wrap coords {
  font-size: 14px !important;
  font-weight: bold !important;
  opacity: 0.8 !important;
}

.test-board .cg-board-wrap coords.ranks {
  right: -40px !important;
  width: 26px !important;
}

.test-board .cg-board-wrap coords.files {
  bottom: -42px !important;
  height: 30px !important;
}
</style>

<style scoped>
.test-page {
  padding: 2rem;
}

.test-board {
  width: 600px;
  height: 600px;
}
</style>
